module.exports = __webpack_public_path__ + "e00ffcc850352e61d6a522bb23d803ec.pdf";